import classcat from "classcat";
import React, { useMemo } from "react";

import {
  CIRCULAR_THUMBNAILS_LIMIT,
  CircularThumbnailSize,
} from "@is/constants/collections";

import CircularThumbnail from "./CircularThumbnail";
import { TRANSLATE_X } from "./CircularThumbnails.constants";
import css from "./CircularThumbnails.module.css";

type Props = {
  thumbnails: string[];
  totalItems: number;
  limit?: number;
  intermediateLimit?: number;
  thumbnailSize?: CircularThumbnailSize;
};

const CircularThumbnails = ({
  thumbnails,
  totalItems,
  limit = CIRCULAR_THUMBNAILS_LIMIT,
  intermediateLimit,
  thumbnailSize = CircularThumbnailSize.Medium,
}: Props) => {
  const showItemsLeftThumbnail = useMemo(
    () =>
      intermediateLimit && thumbnails.length === intermediateLimit
        ? false
        : totalItems > limit,
    [intermediateLimit, limit, thumbnails, totalItems]
  );

  const thumbnailsToShow = useMemo(() => {
    if (intermediateLimit && thumbnails.length === intermediateLimit) {
      return thumbnails;
    }

    if (thumbnails.length <= limit) {
      return thumbnails;
    }

    return thumbnails.slice(0, limit);
  }, [intermediateLimit, limit, thumbnails]);

  return (
    <div
      className={css.container}
      style={{
        transform: `translateX(${thumbnailsToShow.length * TRANSLATE_X}px)`,
      }}
    >
      {thumbnailsToShow.map((thumbnail, index) => (
        <CircularThumbnail
          key={index}
          index={index}
          thumbnailUrl={thumbnail}
          thumbnailUrls={thumbnailsToShow}
          thumbnailSize={thumbnailSize}
        />
      ))}
      {showItemsLeftThumbnail && (
        <div
          className={classcat([
            css.itemsLeftThumbnail,
            {
              [css.large]: thumbnailSize === CircularThumbnailSize.Large,
              [css.medium]: thumbnailSize === CircularThumbnailSize.Medium,
            },
          ])}
          style={{
            transform: `translateX(${
              thumbnailsToShow.length * -TRANSLATE_X
            }px)`,
          }}
        >
          {`+${totalItems - limit}`}
        </div>
      )}
    </div>
  );
};

export default CircularThumbnails;
